<template>
  <!-- <div class="flex"> -->
  <div class="h-full py-4">
    <nav
      class="flex flex-1 flex-col justify-between h-full"
      aria-label="Sidebar"
    >
      <!-- <div class="p-4 items-center">
        <IvyIcon :withText="true" width="28" color="#0d9488" />
      </div> -->
      <div class="pt-2 space-y-4 pb-4 border-b dark:border-white/10">
        <div class="px-2">
          <OrganizationSwitcher
            v-if="isSignedIn"
            :appearance="appearance"
            :organization-profile-props="{ appearance }"
            :hide-personal="true"
            :skipInvitationScreen="true"
            :hide-slug="true"
          />
        </div>

        <!-- add table -->
        <!-- <router-link
          v-if="false"
          :to="{ name: 'table', params: { id: '' } }"
          class="flex space-x-2 bg-white border rounded-lg px-2 py-2 mx-3 text-sm font-medium text-gray-700 hover:bg-primary hover:bg-opacity-10 cursor-pointer text-center"
          active-class="bg-primary  text-primary"
          @click="emit('close')"
        >
          <PlusIcon class="h-5 w-5" />
          <div>Add table</div>
        </router-link> -->
      </div>
      <!-- <div class="space-y-1 flex-auto overflow-y-auto mt-4"></div> -->
      <!-- tables -->

      <div class="flex-auto overflow-y-auto mt-4">
        <!-- new table button -->

        <div class="pb-2">
          <router-link
            :to="{ name: 'new-table' }"
            class="flex space-x-2 bg-white border rounded-lg px-2 py-2 mx-3 font-medium text-gray-700 hover:bg-primary hover:bg-opacity-10 cursor-pointer text-center"
            active-class="bg-primary  text-primary"
          >
            <PlusIcon class="h-5 w-5" />
            <span class="text-xs">New Table</span>
          </router-link>
        </div>
        <div v-for="section in navigationMain" class="space-y-0.5 pb-8">
          <div
            class="px-4 text-xs font-medium text-zinc-500 dark:text-zinc-400"
          >
            {{ section.sectionTitle }}
          </div>

          <div v-for="item in section.items" class="">
            <!-- active-class="!text-primary bg-slate-200/75 dark:bg-slate-900" -->
            <router-link
              v-if="item.route"
              :key="item.name"
              :to="item.route"
              :class="[
                // 'text-gray-700 dark:text-gray-300 hover:text-primary hover:bg-slate-200 dark:hover:bg-slate-900 rounded-lg cursor-pointer',
                'border-l-2 border-transparent flex w-full px-2',
              ]"
              active-class="!text-primary !border-primary"
              @click="
                store.side.show = false;
                emit('close');
              "
              v-slot="{ isActive }"
            >
              <!-- <div v-if="isActive" class="text-primary">{{ item.name }}</div> -->
              <span
                :class="[
                  'text-sm font-medium  hover:text-primary hover:bg-zinc-950/5 dark:hover:bg-slate-800 cursor-pointer',
                  'w-full flex gap-x-3  py-1.5 text-xs leading-6 font-normal items-center rounded-lg',
                  isActive
                    ? 'text-primary'
                    : 'text-zinc-950  dark:text-gray-300',
                ]"
              >
                <component :is="item.icon" class="h-5 w-5 ml-2" />
                {{ item.name }}
              </span>
            </router-link>
            <a
              v-else-if="item.href"
              :key="item.name + 'h'"
              :href="item.href"
              :class="[
                // 'text-sm font-medium text-zinc-950 dark:text-gray-300 hover:text-primary hover:bg-gray-200 dark:hover:bg-slate-900 cursor-pointer',
                // ' group flex gap-x-3 p-2 text-xs leading-6 font-normal items-center',
                'border-l-2 border-transparent flex w-full px-2',
              ]"
              :target="item.target || '_blank'"
            >
              <span
                :class="[
                  'text-sm font-medium  hover:text-primary hover:bg-zinc-950/5 dark:hover:bg-slate-800 cursor-pointer',
                  'w-full flex gap-x-3  py-1.5 text-xs leading-6 font-normal items-center rounded-lg',
                  'text-zinc-950  dark:text-gray-300',
                ]"
              >
                <component :is="item.icon" class="h-5 w-5 ml-2" />
                {{ item.name }}
              </span>
            </a>
          </div>
        </div>
      </div>

      <!-- <div v-if="false" class="space-y-1 flex-auto overflow-y-auto mt-4">
        <div class="px-4 text-gray-400 text-xs font-normal">Tables</div>

        <div v-if="loading && _.isEmpty(tables)" class="px-2">
          <Spinner class="h-5 w-5" />
        </div>

        <div v-for="table in tables" class="px-2 flex group w-full">
          <router-link
            :key="table.id"
            :to="{
              name: 'table',
              params: { id: table.id },
            }"
            :class="[
              'flex-1 text-gray-700 hover:text-primary hover:bg-gray-100 rounded-lg cursor-pointer',
              ' group flex gap-x-3 px-2 py-1 ml-[2px] text-xs leading-6 font-normal ',
            ]"
            active-class=" text-primary bg-gray-200/60"
            @click="emit('close')"
          >
            <TableCellsIcon class="flex-none h-5 w-5 mt-1" />
            <div>
              {{ table.name }}
            </div>
          </router-link>
          <button
            class="w-7 hover:bg-gray-100 text-gray-400 hover:text-red-500 rounded-lg p-0.5"
            @click="deleteTable(table.id)"
          >
            <TrashIcon class="group-hover:block lg:hidden h-5 w-5" />
          </button>
        </div>
      </div> -->

      <div class="flex border-t dark:border-white/10 pt-4">
        <div class="space-y-1 flex-auto">
          <div class="pl-1">
            <UserButton
              ref="userButton"
              v-if="isSignedIn"
              :showName="true"
              :appearance="appearance"
              :user-profile-props="{ appearance }"
            />
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import IvyIcon from "@/components/IvyIcon.vue";

import {
  BookOpenIcon,
  ChatBubbleBottomCenterTextIcon,
  CircleStackIcon,
  CreditCardIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  MagnifyingGlassIcon,
  PlusIcon,
  TableCellsIcon,
  TrashIcon,
  LockClosedIcon,
  BugAntIcon,
  DocumentMagnifyingGlassIcon,
  LightBulbIcon,
  ChevronDoubleRightIcon,
  CalendarIcon,
  FolderIcon,
} from "@heroicons/vue/24/solid";

import { OrganizationSwitcher, UserButton, useUser } from "@clerk/vue";
import _ from "lodash";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "@/store";
import { sharedStyles } from "@/sharedClerkTailwindStyles";
import { DefaultService as api } from "@/client";
import { notifyNegative, notifyPositive } from "@/helperfunctions";
import Spinner from "@/components/utils/Spinner.vue";
import { Square3Stack3DIcon } from "@heroicons/vue/24/solid";
import { LinkIcon } from "@heroicons/vue/24/solid";
import { PuzzlePieceIcon } from "@heroicons/vue/24/solid";
// import ApiKeyNudge from "@/components/ApiKeyNudge.vue";

const appearance = sharedStyles;

const store = useStore();

const emit = defineEmits(["close"]);

const { isSignedIn } = useUser();

// const navigationTables = computed(() => [
//   {
//     sectionTitle: "Tables",
//     items: [
//       ...tables.value.map((table) => ({
//         name: table.name,
//         route: {
//           name: "table",
//           params: { id: table.id },
//         },
//         id: table.id,
//         icon: TableCellsIcon,
//       })),
//       // {
//       //   name: "Add Table",
//       //   route: {
//       //     name: "table",
//       //     params: { id: "" },
//       //   },
//       //   icon: PlusIcon,
//       // },
//     ],
//   },
// ]);

// const route = useRoute();
// const router = useRouter();

// function deleteTable(id) {
//   api
//     .deleteTableResult(id)
//     .then(() => {
//       store.triggerEvent("update-tables");
//       notifyPositive("Table deleted");

//       // if current
//       if (route.params.id === id) {
//         router.push({ name: "table", params: { id: "" } });
//       }
//     })
//     .catch((err) => {
//       console.log(err);
//       notifyNegative("Error deleting table");
//     });
// }

const navigationMain = [
  // {
  //   sectionTitle: "IvyCheck Cloud",
  //   items: [
  //     {
  //       name: "Database Connections",
  //       route: {
  //         name: "dbConnections",
  //       },
  //       icon: CircleStackIcon,
  //     },
  //     {
  //       name: "LLM Providers",
  //       route: {
  //         name: "models",
  //       },
  //       icon: ChatBubbleBottomCenterTextIcon,
  //     },
  //     {
  //       name: "Job Configs",
  //       route: {
  //         name: "jobconfigs",
  //       },
  //       icon: PlayCircleIcon,
  //     },
  //   ],
  // },
  {
    sectionTitle: "",
    items: [
      // {
      //   name: "Projects",
      //   route: {
      //     name: "projects",
      //   },
      //   icon: FolderIcon,
      // },
      // {
      //   name: "Workflows",
      //   route: {
      //     name: "workflows",
      //   },
      //   // icon: DocumentMagnifyingGlassIcon,
      //   icon: Square3Stack3DIcon,
      // },
      {
        name: "Tables",
        route: {
          name: "tables",
        },
        icon: TableCellsIcon,
      },
      // {
      //   name: "Agents",
      //   route: {
      //     name: "agents",
      //   },
      //   icon: ChatBubbleBottomCenterTextIcon,
      // },
      // {
      //   name: "Integrations",
      //   route: {
      //     name: "integrations",
      //   },
      //   // icon: CircleStackIcon,
      //   icon: PuzzlePieceIcon,
      // },
    ],
  },
  // {
  //   sectionTitle: "Playground",
  //   items: [
  //     {
  //       name: "Calendar",
  //       route: {
  //         name: "calendar",
  //       },
  //       icon: CalendarIcon,
  //     },
  //     {
  //       name: "Answer",
  //       route: {
  //         name: "answer",
  //       },
  //       icon: LightBulbIcon,
  //     },
  //     {
  //       name: "Search",
  //       route: {
  //         name: "search",
  //       },
  //       icon: MagnifyingGlassIcon,
  //     },
  //     // {
  //     //   name: "Scrape",
  //     //   route: {
  //     //     name: "scrape",
  //     //   },
  //     //   icon: BugAntIcon,
  //     // },
  //     // {
  //     //   name: "Extract",
  //     //   route: {
  //     //     name: "extract",
  //     //   },
  //     //   icon: ChevronDoubleRightIcon,
  //     // },
  //   ],
  // },
  {
    sectionTitle: "Account",
    items: [
      {
        name: "API Keys",
        route: {
          name: "manage",
        },
        icon: LockClosedIcon,
      },
      {
        name: "Log",
        route: {
          name: "log",
        },
        icon: DocumentTextIcon,
      },
      {
        name: "Billing",
        route: {
          name: "subscription",
        },
        icon: CreditCardIcon,
      },
      {
        name: "Support",
        href: "mailto:support@ivycheck.com?subject=IvyCheck%20Support%20Request",
        icon: EnvelopeIcon,
        target: "_self",
      },
    ],
  },
  // {
  //   sectionTitle: "API Keys",
  //   items: [
  //     {
  //       name: "IvyLLM API Keys",
  //       route: {
  //         name: "manage",
  //       },
  //       icon: LockClosedIcon,
  //     },
  //   ],
  // },
  // {
  // sectionTitle: "",
  // items: [
  // {
  //   name: "Docs",
  //   href: "https://docs.ivycheck.com",
  //   icon: BookOpenIcon,
  // },
  //     {
  //       name: "Support",
  //       href: "mailto:support@ivycheck.com?subject=IvyCheck%20Support%20Request",
  //       icon: EnvelopeIcon,
  //       target: "_self",
  //     },
  //   ],
  // },
];

const tables = ref([]);

const loading = ref(true);

function getTables() {
  // api.getIvydbTables().then((res) => {
  //   tables.value = res.tables;
  // });

  loading.value = true;

  api
    .getTableResultsByOrg()
    .then((res) => {
      // console.log(res);
      tables.value = res;
    })
    .catch((err) => {
      console.log(err);
      notifyNegative("Failed to load tables.");
    })
    .finally(() => {
      loading.value = false;
    });
}

// getTables();

// watch(
//   () => store.event,
//   () => {
//     if (store.event === "update-tables") {
//       getTables();
//       store.event = null;
//     }
//   }
// );

// const activeOrg = useOrganization();

// watch(
//   () => activeOrg?.organization?.id,
//   () => {
//     // if route is table/:id, go to /table
//     // if (route.name === "table" && route.params.id) {
//     //   console.log("redirecting");
//     //   router.push({ name: "table", params: { id: undefined } });
//     // }
//     console.log("fetching tables");
//     // getTables();
//   }
// );
</script>
